/* eslint-disable */
import React, { useState } from "react";
import Container from "../UI/Container";

import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import AddIcon from '@mui/icons-material/Add';
import { maxColumnWidth } from "../../util";
import {
  Button,
  Stack,
  Autocomplete,
  TextField,
  Menu,
  MenuItem,
  Grid, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle

} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import {
  DataGridPro,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import axios from "../../api";
import AddCustomerModal from "../UI/addCustomer";
import AddEmployeeModal from "../UI/addEmployee";
import { usePopUpContext } from "../../Context/PopupMessage";
import DeleteIcon from '@mui/icons-material/Delete';

function BrowseContainer(props) {
 


  const [alertOpen, setAlertOpen] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState();

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleDelete = () => {
    console.log("Deleted");
    const updOid = localStorage.getItem("updOid");
    var postData = {
      prsMd: "D",
      esvLgnId: deleteId,
      updOid :updOid
    };

    console.log(postData)
    axios
      .post("/usermaintenance", postData)
      .then((res) => {
        setLoading(false)
        handleGo()
        handleAlertClose()
      })
      .catch((err) => {
        setLoading(false)
        console.log(err)
        handleAlertClose()
        setPopupMessage({ state: true, type: "error", message: err.response.data?.Message })
      });
  }
  const apiRef = useGridApiRef();

  const [assetColumns, setAssetColumns] = useState([
    {
      field: "pencil_icon",
      headerName: "",
      renderCell: (params) => {
       
         return  params.row.enblEdt===0?<></>:<EditIcon sx={{ height: "30px", color: "#6D92A5" }} />},
      sortable: false,
      width: 30,
    },
    {
      field: "delete_icon",
      headerName: "",
      renderCell: (params) => 
      
      {
        return  params.row.enblDel===0?<></>:  <DeleteIcon sx={{ height: "30px", color: "#6D92A5" }} />
      },
    
      sortable: false,
      width: 30,
    },
    {
      field: "lgnId1",
      headerName: "Login ID",
      sortable: false,
      width: 150,
    },
    { field: "longNm", headerName: "Name", sortable: false, width: 150 },

    {
      field: "typDesc",
      headerName: "Type",
      sortable: false,
      width: 150,
    },
    {
      field: "emailStf",
      headerName: "Email Address",
      renderCell: (params) => (
        <div
          dangerouslySetInnerHTML={{
            __html: params.value,
          }}
        />
      ),
      sortable: false,
      width: 300,
    },
  ]);
  const [typingTimer, setTypingTimer] = useState();

  const [isEdit, setIsEdit] = useState(false);
  const SearchServiceCall = (async (newValue, parms, setOption, setOpen) => {
  
    clearTimeout(typingTimer);
    if (newValue) {
      const typingTimer_ = setTimeout(async () => {
        setLoading(true)
        //console.log("service call-------------------------------------------------")
        getValue(parms, setOption, setOpen);
      }, 1000);
      setTypingTimer(typingTimer_);
    } else {
      getValue({ prsMd: parms.prsMd }, setOption, setOpen);
    }
  });
  const [openGroup, setOpenGroup] = useState(false);
  const [groupOption, setGroupOption] = useState([]);
  const [groupValue, setGroupValue] = useState("");

  const [openBranch, setOpenBranch] = useState(false);
  const [branchOption, setBranchOption] = useState([]);
  const [branchValue, setBranchValue] = useState(null);

  const [loginIDValue, setLoginIDValue] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const [data, setData] = useState();
  const { setPopupMessage, setLoading } = usePopUpContext();
  const [rows, setRows] = useState([]);

  const handleGo = async (e) => {
    e?.preventDefault()
    setLoading(true)
    var postData = {
      prsMd: "P",
    };
    if (loginIDValue) {
      postData["lgnId1"] = loginIDValue;
    }
    if (groupValue) {
      postData["grpNm"] = groupValue?.keyStr;
    }
    if (branchValue) {
      postData["brh"] = branchValue?.keyStr;
    }
    console.log(postData);
    const data = await getAll(postData)
    if (data.success) {
      setLoading(false)
      setRows(data.rowsData);
      const updatedData = assetColumns.map(x => (x.field === "emailStf" || x.field === "pencil_icon" || x.field === "delete_icon" ? x : { ...x, width: maxColumnWidth(x.field, data.rowsData) }));
      setAssetColumns(updatedData)
    }
  }
  const
    handleEdit = (params) => {
      const updOid = localStorage.getItem("updOid");
      var postData = {
        prsMd: "R",
        esvLgnId: params.row.lgnId1,
        updOid :updOid
      };

      console.log(postData)
      axios
        .post("/usermaintenance", postData)
        .then((res) => {
          setLoading(false)
          var arrResponse = res.data.output;
          setData(arrResponse);
          if(res.data.output.rtnSts===2){
            setPopupMessage({ state: true, type: "warning", message:res.data.output?.msg })
          }
          if (params.row.typ === 'c') {
            setIsEdit(true);
            setOpenCustomerModal(true);
          }
          else if (params.row.typ === 'r' || params.row.typ === 'e') {
            setIsEdit(true);
            setOpenEmployeeModal(true);
          }else{
            setIsEdit(true);
            setOpenEmployeeModal(true);
          }
        })
        .catch((err) => {
          setLoading(false)
          console.log(err)
          setPopupMessage({ state: true, type: "error", message: err.response.data?.Message })
        });
    }


  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const getValue = (params, setValue, setOpen) => {
    setLoading(true)
    let url = "/lookupsvc";
    console.log(params);
    axios
      .post(url, params)
      .then((res) => {
        setLoading(false);
       
        var arrResponse = res.data.output.fldTbl;
        setValue(arrResponse);
        setOpen(true);
        if(res.data.output.rtnSts===2){
          setPopupMessage({ state: true, type: "warning", message:res.data.output?.msg })
        }
      })
      .catch((e) => {
        console.log(e);
        setLoading(false)
        //  setPopupMessage({ state: true, type: "error", message: "Something went wrong please try again." })
      });
  };

  const [openCustomerModal, setOpenCustomerModal] = useState(false);
  const [openEmployeeModal, setOpenEmployeeModal] = useState(false);

  const addCustomerHandler = () => {
    console.log("Adding Customer");
    setIsEdit(false);
    setOpenCustomerModal(true);
  };

  const hideAddCustomerModal = () => {
    setOpenCustomerModal(false);
  };


  const addEmployeeHandler = () => {
    setIsEdit(false);
    console.log("Adding Employee");
    setOpenEmployeeModal(true);
  };

  const hideAddEmployeeModal = () => {
    setOpenEmployeeModal(false);
  };
  const handleCellClick = (params) => {
    if (params.field === "pencil_icon") {
      if(params.row.enblEdt !==0){
        handleEdit(params);
      }
     
    }
    if (params.field === "delete_icon") {
      if(params.row.enblDel !==0){
        setAlertOpen(true);
        setDeleteId(params.row.lgnId1);
      }
     
    }
    if (params.field === "emailStf") {
      console.log(params.row.email1)
      document.location = "mailto:" + params.row.email1 ;
    }
  }


  const getAll = async (postData) => {
    setLoading(true)
    let flag = true;
    let nextRecord = null
    let frstTmFlg = 1
    let rowsData = []
    while (flag) {

      if (nextRecord) {
        postData["sLgnId1"] = nextRecord;
      }

      postData["frstTmFlg"] = frstTmFlg;
      postData["esvLgnId"] = localStorage.getItem("usrLgnId");

      await axios
        .post("/userbrowse", postData)
        .then((res) => {

          frstTmFlg = 0
          rowsData = [...rowsData, ...res.data.output.fldTbl]
          if (res.data.output.eof === 0) {
            flag = true
            nextRecord = res.data.output.nLgnId1;
          } else {
            flag = false
          }
          if(res.data.output.rtnSts===2){
            setPopupMessage({ state: true, type: "warning", message:res.data.output?.msg })
          }

        })
        .catch((err) => {
          setLoading(false)
          flag = false
          setPopupMessage({ state: true, type: "error", message: err.response.data?.Message })
          let data = { success: false, rowsData: rowsData }
          return data
          // setRows([]);
        });
    }
    setLoading(false)
    let data = { success: true, rowsData: rowsData }
    return data

  }
  return (
    <>
      <AddCustomerModal
        open={openCustomerModal}
        callback={handleGo}
        onClose={hideAddCustomerModal} mode={isEdit} data={data}
      />
      <AddEmployeeModal
        open={openEmployeeModal}
        callback={handleGo}
        onClose={hideAddEmployeeModal}
        mode={isEdit} data={data}
      />
      <Container
        sx={{
          overFlow: "auto",
          display: "flex",
          flex: 1,
          flexDirection: "column",
        }}
      >
        {/* Filter */}
        {/* {filterVisibility ? ( */}
        <Container className="ixFilterContainer" sx={{ height: "auto" }}>
          <form onSubmit={(e) => handleGo(e, 1)}>
            <Stack direction="row" spacing={9}>
              <Grid container sx={{ width: "80%" }} spacing={7} direction="row">
                <Grid item xs={1} textAlign="end">Group</Grid>
                <Grid item xs={2}>
                  <Autocomplete
                   noOptionsText="No items found"
                    open={openGroup}
                    onOpen={() => {
                      getValue({ prsMd: "G" }, setGroupOption, setOpenGroup);
                    }}
                    onClose={() => {
                      setOpenGroup(false);
                    }}
                    options={groupOption}
                    isOptionEqualToValue={(option, value) =>
                      option.dispStr === value.dispStr
                    }
                    getOptionLabel={(option) => option.dispStr}
                    onChange={(event, newValue) => {

                      setGroupValue(newValue ? newValue : null);
                      setRows([]);

                    }}
                    renderInput={(params) => <TextField
                      onChange={(e) => SearchServiceCall(e.target.value, { prsMd: "G", srchStr: e.target.value }, setGroupOption,
                        setOpenGroup)}
                      {...params} />}
                  /></Grid>
                <Grid item xs={1} textAlign="end">Login Id</Grid>
                <Grid item xs={1}> <TextField
                  onChange={(e) => {
                    setLoginIDValue(e.target.value)
                    setRows([]);
                  }} />
                </Grid>
                <Grid item xs={1} textAlign="end">Branch</Grid>
                <Grid item xs={3}>
                  <Autocomplete
                   noOptionsText="No items found"
                    open={openBranch}
                    onOpen={() => {
                      getValue({ prsMd: "B" }, setBranchOption, setOpenBranch);
                    }}
                    onClose={() => {
                      setOpenBranch(false);
                    }}
                    options={branchOption}
                    isOptionEqualToValue={(option, value) =>
                      option.dispStr === value.dispStr
                    }
                    getOptionLabel={(option) => option.dispStr}
                    onChange={(event, newValue) => {
                      setBranchValue(newValue ? newValue : null);
                      setRows([]);
                    }}
                    renderInput={(params) => <TextField onChange={(e) => SearchServiceCall(e.target.value, { prsMd: "B", srchStr: e.target.value }, setBranchOption,
                      setOpenBranch)} {...params} />}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Button
                    // onClick={() => handleGo()}                  
                    type="submit"
                    styletype="icon" >
                    <PlayArrowIcon />
                  </Button>
                </Grid>
              </Grid>
            </Stack>
          </form>
        </Container>
        
        <div className="spacing"> </div>
        <Container
          className="ixBrowseGridLayout"
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Container className="ixBrowseGridActionBar" sx={{ height: "50px " }}>
            < Stack
              className="ixBrowseGridActionBarContents"
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              spacing={0.5}
            >
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Button onClick={addCustomerHandler} startIcon={<AddIcon/>}> Customer</Button>
                <Button onClick={addEmployeeHandler} startIcon={<AddIcon/>}> Employee</Button>
              </Stack>
            </Stack>
        
            <Menu
              PaperProps={{
                
                className: "invPopupMenuVeryDark",
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
             
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
            >
              <MenuItem>Export</MenuItem>
              <MenuItem>Help</MenuItem>
            </Menu>
          </Container>
          <Container className="ixBrowseGridContainer">
            <DataGridPro
              headerHeight={40}
              columnBuffer={10}
              hideFooter={true}
              apiRef={apiRef}
              columns={assetColumns}
              rowHeight={30}
              disableColumnMenu={true}
              getRowId={(row) => row.lgnId1}
              rows={rows}
              onCellClick={handleCellClick}
            />
          </Container>
        </Container>
      </Container>
      <Dialog
        open={alertOpen}
        onClose={handleAlertClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description" fullWidth>
        <DialogTitle id="alert-dialog-title">
          {"Delete"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you want to delete this row?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAlertClose}>No</Button>
          <Button onClick={handleDelete} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default BrowseContainer;
